import TestCollectionForm from './TestCollectionForm';
import TestCollectionList from './TestCollectionList';
import styles from './TestCollection.module.css';
import { useTheme } from '../../../hooks/useTheme';

function TestCollection() {
  const { theme } = useTheme();

  return (
    <>
      <div className={`${styles.container} ${styles.containerPadding} ${theme ? styles.containerLight : styles.containerDark}`}>
        <div className="row">
          <div className={`lg-4 md-12 sm-12 ${styles.leftPanel} ${theme ? styles.borderRightLight : styles.borderRightDark}`}>
            <div className="header">
              <span className={styles.title}>Import Test Collection</span>
            </div>
            <p className={styles.subtitle}>
              Provide the required details and choose whether to upload a custom test collection file or use the system's default
              collection.
            </p>
            <TestCollectionForm />
          </div>
          <div className={`lg-8 md-12 sm-12 ${styles.midPanel}`}>
            <div className="header">
              <span className={styles.title}>Test Collection List</span>
            </div>
            <p className={styles.subtitle}>View all existing test collections. Review details and remove any collection as needed.</p>
            <TestCollectionList />
          </div>
        </div>
      </div>
      {/* <ReactEDSWrapper
                component={MultiPanelTile} 
                title={`Test Collection List`}
                style={{minHeight: '100%', minWidth: '60%'}}
                leftPanel={
                    <ReactEDSWrapper 
                    component={Panel}
                    title={`Import a Test Collection`}
                    style={{minWidth: '40%'}}>
                        <TestCollectionForm />
                    </ReactEDSWrapper>
                }
                leftPanelOpen={true} 
                >
                    <TestCollectionList />
            </ReactEDSWrapper> */}
    </>
  );
}
export default TestCollection;
